import {Navigate, Outlet, useLocation} from "react-router-dom";

export default function AppLayout() {
    return <main className="App">
        <Outlet/>
    </main>;
}
